import React from "react"
import containerStyles from "./container.module.css"
import Header from "../components/header"
import { graphql, useStaticQuery } from "gatsby"
import { Helmet } from "react-helmet"

const ga = () => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || []
    function gtag() {
      dataLayer.push(arguments)
    }
    gtag("js", new Date())

    gtag("config", "G-PCM38SCSTD")
  }
}

export default ({ children, whyDevNano, author }) => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  )
  return (
    <div className={containerStyles.container}>
      <header id={containerStyles.header}>
        <Helmet>
          <title>{data.site.siteMetadata.title}</title>
          {/* <!-- Global site tag (gtag.js) - Google Analytics --> */}
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-PCM38SCSTD"
          ></script>
          <script>{ga()}</script>
        </Helmet>
        <Header
          title={data.site.siteMetadata.title}
          whyDevNano={whyDevNano}
          author={author}
        />
      </header>
      <main id={containerStyles.content}>{children}</main>
    </div>
  )
}

// #3 GraphQL fragment to be included in every query that requires
// header data
export const headerFragment = graphql`
  fragment HeaderFragment on Query {
    whyDevNano: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        fileAbsolutePath: { regex: "/why/" }
        fields: { langKey: { eq: $langKey } }
      }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
          }
          fields {
            slug
          }
        }
      }
    }
    author: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        fileAbsolutePath: { regex: "/author/" }
        fields: { langKey: { eq: $langKey } }
      }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
          }
          fields {
            slug
          }
          html
        }
      }
    }
  }
`
